export const apiLink =
  'https://api.globalcredit.ua/static/gc/PartnerDepartments.json';

export const apiTrackLink = 'https://api.globalcredit.ua/track-gc';

export const apiCalcLink = 'https://api.globalcredit.ua/calc-track-gc';
